var jade = require("C:\\Users\\kop\\Repos\\webpack\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
var locals_ = (locals || {}),abc = locals_.abc,self = locals_.self;
buf.push("<p>" + (jade.escape(null == (jade_interp = typeof abc === "undefined" ? "self" + self.abc : abc) ? "" : jade_interp)) + "</p>" + (null == (jade_interp = require("C:\\Users\\kop\\Repos\\webpack\\test\\cases\\loaders\\_resources\\included.jade").call(this, locals)) ? "" : jade_interp));;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/_resources/template.jade
 ** module id = 7
 ** module chunks = 0
 **/